import React, { useState } from "react";
import { staff, projects } from "./data";

const Home = ({ onStart }) => {
  const [projectLife, setProjectLife] = useState(5000);
  const [activeHero, setActiveHero] = useState(null); // {hero, idx}

  const showPrevHero = (e) => {
    e.stopPropagation();
    if (!activeHero) return;
    const prevIdx = (activeHero.idx - 1 + staff.length) % staff.length;
    setActiveHero({ hero: staff[prevIdx], idx: prevIdx });
  };

  const showNextHero = (e) => {
    e.stopPropagation();
    if (!activeHero) return;
    const nextIdx = (activeHero.idx + 1) % staff.length;
    setActiveHero({ hero: staff[nextIdx], idx: nextIdx });
  };

  // Selected hero for each category -> { hero, idx }
  const [selectedHeroes, setSelectedHeroes] = useState({});

  const categoryOrder = Array.from(new Set(staff.map((h) => h.category)));

  const categories = staff.reduce((acc, hero, idx) => {
    acc[hero.category] = acc[hero.category] || [];
    acc[hero.category].push({ hero, idx });
    return acc;
  }, {});


  const handleStart = () => {
    const heroes = categoryOrder.map((cat) => selectedHeroes[cat]?.hero);
    if (heroes.some((h) => !h)) {
      alert("Please choose heroes from all categories.");
      return;
    }
    onStart({
      heroes,
      heroLife: heroes.map((h) => h.life),
      enemyLife: projectLife,
      bgColor: heroes[0].color,
    });
  };

  return (
    <div className="home">
      <h1>Corporate Battles</h1>
      <p>
        Choose your heroes and project. Different life will affect the progress
        bars.
      </p>

      <h2>Heroes</h2>
      <div className="hero-sections">
      {Object.entries(categories).map(([cat, heroes]) => (
        <div key={cat}>
          <h3>{cat}</h3>
          <div className="hero-grid">
            {heroes.map(({ hero, idx }) => {
              const selected = selectedHeroes[hero.category];
              const isSelected = selected && selected.idx === idx;
              return (
                <div
                  key={idx}
                  className={`hero-card${isSelected ? " selected" : ""}`}
                  style={{
                    borderColor: hero.color,
                    cursor: "pointer",
                    backgroundColor: isSelected ? hero.color : undefined,
                    color: isSelected && hero.color === "yellow" ? "black" : undefined,
                  }}
                  onClick={() => setActiveHero({ hero, idx })}
                >
                  <div className="hero-image">
                    <img
                      className="profile"
                      src={hero.path}
                      alt={hero.fullName}
                    />
                  </div>
                  <div className="hero-name">{hero.fullName}</div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
      </div>

      {activeHero && (
        <div className="hero-modal-overlay" onClick={() => setActiveHero(null)}>
          <button className="hero-nav left" onClick={showPrevHero}>
            &#8656;
          </button>
          <div
            className="hero-modal"
            onClick={(e) => e.stopPropagation()}
            style={{ borderColor: activeHero.hero.color }}
          >
            <div className="hero-image">
              <img
                className="profile"
                src={activeHero.hero.path}
                alt={activeHero.hero.fullName}
              />
            </div>
            <h3>{activeHero.hero.fullName}</h3>
            <p>{activeHero.hero.desc}</p>
            <p>{activeHero.hero.life} HP</p>
            <button
              onClick={() => {
                setSelectedHeroes((prev) => ({
                  ...prev,
                  [activeHero.hero.category]: { hero: activeHero.hero, idx: activeHero.idx },
                }));
                setActiveHero(null);
              }}
            >
              Choose
            </button>
          </div>
          <button className="hero-nav right" onClick={showNextHero}>
            &#8658;
          </button>
        </div>
      )}

      <h2>Project</h2>
      <div className="project-grid">
        {projects.map((p) => (
          <label
            key={p.life}
            className={`project-card${projectLife === p.life ? " selected" : ""}`}
            style={{ borderColor: p.color, "--project-color": p.color }}
          >
            <input
              type="radio"
              name="project"
              value={p.life}
              checked={projectLife === p.life}
              onChange={() => setProjectLife(p.life)}
            />
            <div className="project-image">
              <img className="profile" src={p.path} alt={p.fullName} />
            </div>
            <div className="project-name">{p.fullName}</div>
            <div className="project-desc">{p.desc}</div>
          </label>
        ))}
      </div>

      <button className="start-button" onClick={handleStart}>
        Start Game
      </button>
    </div>
  );
};

export default Home;
